module.exports = __webpack_public_path__ + "static/media/changeme.8296a91b.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/changeme.md
// module id = 1094
// module chunks = 0